import React from 'react';
import { motion } from 'framer-motion';
export function ProofSection() {
  return <section className="py-12 md:py-24 px-4 bg-warm-900 text-cream relative overflow-hidden" data-id="element-194">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(107,127,92,0.12)_0%,transparent_70%)] pointer-events-none" data-id="element-195" />

      <div className="max-w-3xl mx-auto text-center relative" data-id="element-196">
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.6
      }} className="text-sm font-medium text-sage-light tracking-widest uppercase mb-4 md:mb-6" data-id="element-197">
          En las próximas 24 horas
        </motion.p>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7,
        delay: 0.1
      }} className="text-2xl sm:text-3xl md:text-5xl font-bold leading-tight mb-6 md:mb-10" data-id="element-198">
          Mañana, esa pregunta <br data-id="element-199" />
          <span className="italic text-sage-light font-normal" data-id="element-200">
            ya no existirá.
          </span>
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7,
        delay: 0.2
      }} className="text-base md:text-xl text-cream/80 leading-relaxed font-light" data-id="element-201">
          Cuando cierres el portátil o abras la puerta de casa, no habrá duda.
          No habrá parálisis. Mirarás el tablero, abrirás la nevera y en{' '}
          <strong className="text-cream font-semibold not-italic" data-id="element-202">
            5 minutos estarás sentado cenando
          </strong>{' '}
          — sin tener que pensar en nada más.
        </motion.p>
      </div>
    </section>;
}